import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedAttachments = createPaginatedSlice('paginatedAttachments');

export const paginatedAttachmentsActions = paginatedAttachments.actions;
export const paginatedAttachmentsSelector = (state) => state.paginatedRequestAttachments;
export const paginatedAttachmentsReducer = paginatedAttachments.reducer;
export default paginatedAttachmentsReducer;

export const paginatedAttachmentsSelectors = paginatedAttachments.LF.selectors;
